import { getCookie } from "@/lib/getCookie";
import { Role, roles } from "@/lib/utils";
import { RootState } from "@/redux/store";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = ({ allowedRoles }: { allowedRoles: Role[] }) => {
  // Check for token
  const token = getCookie("accessToken");

  if (!token) {
    return <Navigate to="/" replace />;
  }

  // check for roles
  const loggedInUserData = useSelector(
    (state: RootState) => state.currentData.loggedInUserData
  );
  
  let roleExists = [];

  if (loggedInUserData?.userType == roles.admin.value) {
    roleExists = [roles.admin.value]
  } else {
    roleExists = loggedInUserData?.roleProjectMap?.filter((userRole: any) =>
      allowedRoles.includes(userRole?.roleCode)
    );
  }
  
  return roleExists?.length ? <Outlet /> : <Navigate to="/" replace />;
};

export default ProtectedRoute;
